export default "__VITE_ASSET__LS5y6WDT__"